import { CLUSTERS } from '../clusters.js';
import { CONSTRUCTION_CLUSTER } from '../mapped-clusters/construction.js';
import { CRM_CLUSTER } from '../mapped-clusters/crm.js';
import { DESIGN_AND_CREATIVE_CLUSTER } from '../mapped-clusters/design_and_creative.js';
import { EDUCATION_CLUSTER } from '../mapped-clusters/education.js';
import { FINANCE_CLUSTER } from '../mapped-clusters/finance.js';
import { HR_CLUSTER } from '../mapped-clusters/hr.js';
import { INFORMATION_TECHNOLOGY_CLUSTER } from '../mapped-clusters/information_technology.js';
import { LEGAL_CLUSTER } from '../mapped-clusters/legal.js';
import { MARKETING_CLUSTER } from '../mapped-clusters/marketing.js';
import { NGO_CLUSTER } from '../mapped-clusters/ngo.js';
import { OPERATIONS_CLUSTER } from '../mapped-clusters/operations.js';
import { OTHER_CLUSTER } from '../mapped-clusters/other.js';
import { PMO_CLUSTER } from '../mapped-clusters/pmo.js';
import { PRODUCT_MANAGEMENT_CLUSTER } from '../mapped-clusters/product_management.js';
import { TECH_CLUSTER } from '../mapped-clusters/tech.js';

const SIGNUP_CLUSTERS_AND_SUBCLUSTERS = {
    [CLUSTERS.HR]: { subclusters: HR_CLUSTER.subclusters },
    [CLUSTERS.CONSTRUCTION]: { subclusters: CONSTRUCTION_CLUSTER.subclusters },
    [CLUSTERS.DESIGN_AND_CREATIVE]: { subclusters: DESIGN_AND_CREATIVE_CLUSTER.subclusters },
    [CLUSTERS.INFORMATION_TECHNOLOGY]: { subclusters: INFORMATION_TECHNOLOGY_CLUSTER.subclusters },
    [CLUSTERS.NGO]: { subclusters: NGO_CLUSTER.subclusters },
    [CLUSTERS.EDUCATION]: { subclusters: EDUCATION_CLUSTER.subclusters },
    [CLUSTERS.PMO]: { subclusters: PMO_CLUSTER.subclusters },
    [CLUSTERS.FINANCE]: { subclusters: FINANCE_CLUSTER.subclusters },
    [CLUSTERS.MARKETING]: { subclusters: MARKETING_CLUSTER.subclusters },
    [CLUSTERS.TECH]: { subclusters: TECH_CLUSTER.subclusters },
    [CLUSTERS.OPERATIONS]: { subclusters: OPERATIONS_CLUSTER.subclusters },
    [CLUSTERS.LEGAL]: { subclusters: LEGAL_CLUSTER.subclusters },
    [CLUSTERS.PRODUCT_MANAGEMENT]: { subclusters: PRODUCT_MANAGEMENT_CLUSTER.subclusters },
    [CLUSTERS.CRM]: { subclusters: CRM_CLUSTER.subclusters },
    [CLUSTERS.OTHER]: { subclusters: OTHER_CLUSTER.subclusters },
};

export { SIGNUP_CLUSTERS_AND_SUBCLUSTERS };
